<template>
<div class="chapter">
<div class="inner_page">
<div class="centerImage1" id="cov"><svg:svg height="100%" viewbox="0 0 600 800" width="100%"><svg:image height="800" transform="translate(0 0)" width="600" xlink:href="9781408908150_cover_bbeb.jpg"></svg:image></svg:svg></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781408908150_cover.vue?125c3a8a